import { render, staticRenderFns } from "./HomeRewardIcon.vue?vue&type=template&id=077bc857&scoped=true"
import script from "./HomeRewardIcon.vue?vue&type=script&lang=ts"
export * from "./HomeRewardIcon.vue?vue&type=script&lang=ts"
import style0 from "./HomeRewardIcon.vue?vue&type=style&index=0&id=077bc857&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "077bc857",
  null
  
)

export default component.exports